import React, { useState } from 'react';
import { FaJava, FaReact, FaCode, FaCogs } from 'react-icons/fa';
import { 
  SiDart, 
  SiFlutter, 
  SiCplusplus, 
  SiFirebase, 
  SiPython, 
  SiDjango, 
  SiPostgresql, 
  SiSupabase, 
  SiGit, 
  SiPostman 
} from 'react-icons/si';
import { BiBluetooth } from 'react-icons/bi';
import { TbApi } from 'react-icons/tb';

const Skills = () => {
  const [activeCategory, setActiveCategory] = useState('All');

  const categories = ['All', 'Mobile & IoT', 'Backend & Cloud', 'Languages', 'Tools & Concepts'];

  const skills = [
    // Mobile & IoT
    { name: "Flutter", category: "Mobile & IoT", icon: <SiFlutter color="#02569B" /> },
    { name: "Dart", category: "Mobile & IoT", icon: <SiDart color="#0175C2" /> },
    { name: "BLE / Hardware", category: "Mobile & IoT", icon: <BiBluetooth color="#0082FC" /> },
    
    // Backend & Cloud
    { name: "Python", category: "Backend & Cloud", icon: <SiPython color="#3776AB" /> },
    { name: "Django REST", category: "Backend & Cloud", icon: <SiDjango color="#092E20" /> },
    { name: "Supabase", category: "Backend & Cloud", icon: <SiSupabase color="#3ECF8E" /> },
    { name: "PostgreSQL", category: "Backend & Cloud", icon: <SiPostgresql color="#4169E1" /> },
    { name: "Firebase", category: "Backend & Cloud", icon: <SiFirebase color="#FFCA28" /> },

    // Languages
    { name: "Java", category: "Languages", icon: <FaJava color="#E76F00" /> },
    { name: "C / C++", category: "Languages", icon: <SiCplusplus color="#00599C" /> },
    { name: "React", category: "Languages", icon: <FaReact color="#61DAFB" /> },

    // Tools & Concepts
    { name: "REST APIs", category: "Tools & Concepts", icon: <TbApi color="#2563EB" /> },
    { name: "Git & GitHub", category: "Tools & Concepts", icon: <SiGit color="#F05032" /> },
    { name: "Postman", category: "Tools & Concepts", icon: <SiPostman color="#FF6C37" /> },
    { name: "OOP", category: "Tools & Concepts", icon: <FaCode color="#45505b" /> },
    { name: "DSA", category: "Tools & Concepts", icon: <FaCogs color="#45505b" /> },
  ];

  const filteredSkills = activeCategory === 'All'
    ? skills
    : skills.filter(skill => skill.category === activeCategory);

  const styles = {
    section: {
      padding: '70px 0',
      backgroundColor: '#f8f9fa'
    },
    filterContainer: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      gap: '8px',
      margin: '25px 0 35px 0'
    },
    filterBtn: (isActive) => ({
      padding: '7px 16px',
      borderRadius: '25px',
      border: isActive ? '1px solid #2563eb' : '1px solid #e2e8f0',
      backgroundColor: isActive ? '#2563eb' : '#fff',
      color: isActive ? '#fff' : '#475569',
      fontWeight: '600',
      fontSize: '0.85rem',
      cursor: 'pointer',
      transition: 'all 0.25s ease',
      boxShadow: isActive ? '0 4px 12px rgba(37,99,235,0.25)' : 'none'
    }),
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 130px), 1fr))',
      gap: '16px'
    },
    card: {
      background: '#fff',
      padding: '20px 12px',
      borderRadius: '14px',
      boxShadow: '0 4px 15px rgba(0,0,0,0.04)',
      textAlign: 'center',
      transition: 'all 0.3s ease',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px solid #edf2f7',
      cursor: 'default'
    },
    icon: { 
      fontSize: '2.2rem', 
      marginBottom: '10px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    text: { 
      fontWeight: '600', 
      color: '#2c3e50', 
      margin: '0 0 6px 0',
      fontSize: '0.9rem'
    },
    categoryBadge: {
      fontSize: '0.72rem',
      color: '#64748b',
      backgroundColor: '#f1f5f9',
      padding: '3px 8px',
      borderRadius: '12px',
      fontWeight: '500'
    }
  };

  return (
    <section id="skills" className="skills section" style={styles.section}>
      <div className="container" data-aos="fade-up">
        <div className="section-title text-center">
          <h2>Technical Skills</h2>
          <p>My technical toolbelt for mobile application engineering, backend services, and scalable architecture.</p>
        </div>

        {/* Category Filters */}
        <div style={styles.filterContainer}>
          {categories.map((cat) => (
            <button
              key={cat}
              style={styles.filterBtn(activeCategory === cat)}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Skills Grid */}
        <div style={styles.grid}>
          {filteredSkills.map((skill, index) => (
            <div 
              key={index} 
              style={styles.card} 
              className="skill-card"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-5px)';
                e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,0,0,0.08)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.04)';
              }}
            >
              <div style={styles.icon}>{skill.icon}</div>
              <p style={styles.text}>{skill.name}</p>
              <span style={styles.categoryBadge}>{skill.category}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
